import { HPreparePropertyTitle } from "@rf-helper/property/prepare-title-property";
import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export const prepareDetailPropertyCardTitle = (
  property: IPropertyDetailsResponse
) => {
  return HPreparePropertyTitle({
    propertyType: property.project ? property.projecttype : property.realstate_type,
    sectorName: property.sector,
    cityName: property.city,
    isProject: Boolean(property.project)
  });
};
